<main>
  <header class="document-view-header">
      <section class="document-view-heading">
        <h2>
          <strong>Quick View</strong>:
        </h2>
        <h2>
          {{ data.documentName | titlecase}}
        </h2>
      </section>

      <section class="document-view-buttons">
          <app-split-button [menuItems]= "menuItems" [buttonLabel]="buttonLabel"  mat-button (selected)=selected($event)>
          </app-split-button>
      </section>

  </header>
  <button class="view-button" mat-dialog-close>
      <mat-icon>
          close
      </mat-icon>
  </button>
</main>
<mat-dialog-content class="pdf-view-container">
  <iframe
    class="pdf-view"
    [src]="pdfSource"
    [title]="data.documentName">
  </iframe>
   
</mat-dialog-content>
